import DeleteShopArticleTaxHistoryByIdRequestModelBase from '../_generated/modelBases/delete-shop-article-tax-history-by-id-request-model-base';

export default class DeleteShopArticleTaxHistoryByIdRequestModel extends DeleteShopArticleTaxHistoryByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
